export const isMobileMixin = {
  computed: {
    isMobile() {
      return this.$screen.width <= 992
    },
  },
}

export const isIosSafari = {
  computed: {
    isIosSafari() {
      const ua = window.navigator.userAgent
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i) || !!ua.match(/Macintosh/i)
      const webkit = !!ua.match(/WebKit/i)
      const isChrome = ua.match(/CriOS/i)
      const isFF = ua.match(/FxiOS/i)
      const isEdge = ua.match(/EdgiOS/i)
      return iOS && webkit && !isChrome && !isFF && !isEdge
    },
  },
}
